import {
    RESET_SWING,
    GET_SWING_LIST,
    GET_SWING_LIST_SUCCESS,
    GET_SWING_LIST_ERROR,
} from '../constants/ActionTypes';

export const resetSwing = () => {
    return {
        type: RESET_SWING,
    };
};

export const getSwingList = (payload) => {
    return {
        type: GET_SWING_LIST,
        payload: payload
    };
};

export const getSwingListSuccess = (swingListResponse) => {
    return {
        type: GET_SWING_LIST_SUCCESS,
        payload: swingListResponse
    };
};

export const getSwingListError = (swingListResponse) => {
    return {
        type: GET_SWING_LIST_ERROR,
        payload: swingListResponse
    };
};

